import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import BgImg from "../../../images/case-studies/button-smasher/banner_back.webp";
import { StaticImage } from "gatsby-plugin-image";
import { Link } from "gatsby";

function Banner() {
  return (
    <section
      className="banner_h100 banner_smasher"
      style={{ backgroundImage: `url(${BgImg})` }}
    >
      <Container className="h-100">
        <Row className="h-100">
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <h1 style={{ color: "#000" }}>Button Smasher App Development</h1>
            <p style={{ color: "#000" }}>
              An interactive and trustworthy game rating and review app for all
              the gamerheads out there!
            </p>
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Get Inspired
            </Link>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-xl-1 offset-lg-1 text-center"
          >
            <div className="banner_img">
              <StaticImage
                src="../../../images/case-studies/button-smasher/banner_img.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={371}
                height={700}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Banner;
